import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'caseSettlePoolController';
export default {
    /**
     * 归C案件池列表
     */
    getCaseSettlePoolPageList: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCasePoolPageList',
        type: requestType.Get
    },
};
